import { render, staticRenderFns } from "./product_onlist.vue?vue&type=template&id=794dfe6c&scoped=true"
import script from "./product_onlist.vue?vue&type=script&lang=js"
export * from "./product_onlist.vue?vue&type=script&lang=js"
import style0 from "./product_onlist.vue?vue&type=style&index=0&id=794dfe6c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794dfe6c",
  null
  
)

export default component.exports